export default __webpack_public_path__ + "assets/images/deffc4b1ebd2cb1ad4314a6e37124673.png";